import { homepage } from "../package.json";

const currentOrigin = window.location.origin || "https://webapp.cz.dhl.com",
  currentOriginExtra = currentOrigin + "/";

export default {
  /**
   * WA URL
   */
  WA_URL: `${currentOrigin}${homepage}/`,
  /**
   * URL pro zakaznickou registraci
   */
  REGISTER_URL: `${currentOrigin}/register/`,
  /**
   * Sentry URL
   */
  SENTRY_URL: `https://910372b2f94b4836910cd0fb2337e76c@${
    process.env.NODE_ENV === "development"
      ? "sentry.srv.cz.dhl.com"
      : window.location.hostname
    }/9`,
  /**
   * URL API
   */
  BASE_URL:
    process.env.NODE_ENV === "development"
      ? "https://localhost:5000/"
        //"https://webapp-test.srv.cz.dhl.com/wa/api"
        //"https://webapp.cz.dhl.com/wa/api"
      : `${currentOrigin}${homepage}/api`,
  /**
   *URL hlavního webu - pro získání tokenu
   */
  MAIN_WEB_URL:
    process.env.NODE_ENV === "development"
      ? "http://localhost:8080/web/"
      : currentOriginExtra,
  /**
   * url na dhl freight podminky
   */
  TERMS_DOCUMENT_URL: "http://www.dhl.com/freight/podminky",
  /**
   * url na dhl freight cenik ECD
   */
  PRICELIST_ECD_DOCUMENT_URL:
    "https://www.dhl.com/content/dam/dhl/local/cz/dhl-freight/documents/pdf/cz-freight-price-list-ecd.pdf",
  /**
   * url na dhl freight cenik ECI
   */
  PRICELIST_ECI_DOCUMENT_URL:
    "https://www.dhl.com/content/dam/dhl/local/cz/dhl-freight/documents/pdf/cz-freight-price-list-eci.pdf",
  /**
   * URL v hlavním menu logo DHL
   */
  HOME_URL: currentOriginExtra,
  /**
   * URL v hlavním menu Kontakt
   */
  CONTACT_URL: `${currentOriginExtra}kontakt.html`,
  /**
   * URL v hlavním menu Novinky
   */
  NEWS_URL: "https://dhlfreight.cz", //`${currentOriginExtra}novinky.html`,
  /**
   * URL v hlavním menu Služby
   */
  SERVICES_URL: "https://dhlfreight.cz", //`${currentOriginExtra}sluzby.html`,
  /**
   * URL v patičce Informace o podvodech
   */
  FRAUD_URL:
    "https://www.logistics.dhl/cz-cs/home/paticka/informovanost-o-podvodech.html",
  /**
   * URL v patičce Právní oznámení
   */
  LEGAL_URL:
    "https://www.logistics.dhl/cz-cs/home/paticka/pravni-oznameni.html",
  /**
   * URL v patičce Smluvní podmínky
   */
  CONTRACTUAL_URL:
    "https://www.logistics.dhl/cz-en/home/footer/terms-of-use.html",
  /**
   * URL v patičce Oznámení o ochraně soukromí
   */
  PRIVACY_URL:
    "https://www.logistics.dhl/cz-cs/home/paticka/oznameni-o-ochrane-soukromi.html",
  /**
   * URL v patičce Řešení sporů
   */
  DISPUTE_URL:
    "https://www.logistics.dhl/cz-en/home/footer/dispute-resolution.html",
  /**
   * URL v patičce Přístupnost
   */
  ACCESSIBILITY_URL:
    "https://www.logistics.dhl/cz-en/home/footer/accessibility.html",
  /**
   * URL v patičce YouTube
   */
  YOUTUBE_URL: "https://www.youtube.com/user/dhl",
  /**
   * URL v patičce Facebook
   */
  FACEBOOK_URL: "https://www.facebook.com/dhl",
  /**
   * URL v patičce LinkedIn
   */
  LINKEDIN_URL: "https://www.linkedin.com/company/dhl",
  /**
   * URL v patičce Instagram
   */
  INSTAGRAM_URL: "https://www.instagram.com/dhl_global/",
  /**
   * čas pro http požadavek [ms]
   */
  TIMEOUT: process.env.NODE_ENV === "development" ? 60000 : 20000,
  /**
   * cas zobrazeni zprávy uživateli
   */
  MESSAGE_DURATION: 5,
};
